import React, { useCallback, useState } from 'react'
import styled from 'styled-components'
import TransferData from 'core/component/TransferData'
import { Modal, Select } from 'antd'

export const Label = styled.div`
  display: grid;
  justify-content: start;
  align-content: center;
  margin-right: 5px;
`
const defaultTargetKeys = []

const UnitPerfEditModal = ({
  data,
  tableData,
  visible,
  groupTypes,
  groups,
  allUnits,
  closePopup,
  onOK,
}) => {
  const [baseData, setBaseData] = useState(
    data.isNew
      ? {
          groupType: 'Fuel',
          groupName: groups.length > 0 ? groups[0].groupName : undefined,
          units: defaultTargetKeys,
        }
      : data
  )

  const onChange = (key, value) => {
    setBaseData(d => ({ ...d, [key]: value }))
  }

  const getDataSource = useCallback(() => {
    const restrictedUnits = tableData
      .filter(t => t.groupType === baseData.groupType)
      .map(u => u.unitId)
    const result = allUnits.filter(e => !restrictedUnits.includes(e.unitId))
    const selectedUnits = data.isNew
      ? []
      : allUnits.filter(u => baseData.units.includes(u.unitId))

    return [...result, ...selectedUnits]
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allUnits, baseData.groupType, data.isNew, tableData])

  return (
    <Modal
      title={(data.isNew ? 'Create' : 'Update') + ' Unit Performance Group'}
      visible={visible}
      onOk={_ => {
        onOK({ isNew: !!data.isNew, groupData: baseData })
        // closePopup()
      }}
      onCancel={_ => closePopup()}
      width={910}
      height={100}
      top={20}
    >
      <div style={{ display: 'flex' }}>
        <Label>Group Type :</Label>
        <Select
          style={{ width: '150px' }}
          value={baseData.groupType}
          onChange={c => onChange('groupType', c)}
          disabled={!data.isNew}
        >
          {groupTypes.map(tt => (
            <Select.Option key={tt} value={tt}>
              {tt}
            </Select.Option>
          ))}
        </Select>
        <Label style={{ marginLeft: '20px' }}>Group Name :</Label>
        <Select
          value={baseData.groupName}
          onChange={c => onChange('groupName', c)}
          style={{ width: '250px' }}
          disabled={!data.isNew}
        >
          {groups.map(({ groupName }) => (
            <Select.Option key={groupName} value={groupName}>
              {groupName}
            </Select.Option>
          ))}
        </Select>
      </div>
      <TransferData
        titles={['All Units', 'Unit Authorized to Group']}
        showSearch={false}
        showSelectAll
        isRightListSelectionStoreRequired={false}
        dataSource={getDataSource()}
        rowKey={d => d.unitId}
        render={d => d.unit + '-' + d.unitName}
        targetKeys={baseData.units || []}
        setTargetKeys={d => onChange('units', d)}
        style={{
          display: 'grid',
          gridTemplateColumns: '400px 30px 400px',
          gridTemplateRows: '1fr',
          gridColumnGap: '10px',
          margin: '1px',
        }}
        listStyle={{
          height: 300,
          maxHeight: 300,
          width: '400px',
          margin: '5px',
        }}
        operationStyle={{
          alignSelf: 'center',
          justifySelf: 'center',
        }}
      />
    </Modal>
  )
}

export default UnitPerfEditModal
